import styles from './Participants.module.css'
import ProfileCard from '../ProfileCard/ProfileCard'
import logo from '../../assets/les-logo.png'
import CustomSlider from '../CustomSlider/CustomSlider';
import SeeAllButton from '../SeeAllButton/SeeAllButton';

function Participants(){
    const elements = Array.from({ length: 100 }, (v, k) => <ProfileCard key={k} imageUrl={logo} name='Lorem ipsum' seeMore={'Ver mais'} withButton={true} withIconGit={true}/>);
    
    return(
        <div className={styles.container}>
            <div className={styles.content}>
                <div className={styles['title-container']}>
                    <div className={styles.title + ' ' + styles.division}>
                        PARTICIPANTES
                    </div>
                    <div className={styles.seeAllButton}>
                        <SeeAllButton type={3} routertype={'/participantes'}/>
                    </div>
                </div>
                
                
                <CustomSlider elements={elements}/>            
            </div>
            
        </div>
    )
}

export default Participants